import React from "react";
import { Link } from "react-router-dom";
import "./Layout.scss";
import strings from "../Language";

import { IconHome, IconQuant, IconChart, IconProfile, IconBell } from "../Icons";
import { Helmet } from "react-helmet";
import { images } from "../../config/image";
// import ctcbotLogo from './../../assets/images/ctcbot_logo_12.png';

class Layout extends React.Component {
    constructor(props) {
        super(props);
        var headerData = this.props && this.props.data ? this.props.data : {};
        var headerTitle =
            this.props && this.props.data && this.props.data.title
                ? this.props.data.title
                : "";
        var is_logs =
            this.props && this.props.data && this.props.data.is_logs
                ? this.props.data.is_logs
                : false;
        var is_logs_b =
            this.props && this.props.data && this.props.data.is_logs_b
                ? this.props.data.is_logs_b
                : false;
        var is_logo =
            this.props && this.props.data && this.props.data.is_logo
                ? this.props.data.is_logo
                : false;
        this.state = {
            lang: strings.getLanguage(),
            headerData: headerData,
            headerTitle: headerTitle,
            is_logs: is_logs,
            is_logo: is_logo,
            is_logs_b: is_logs_b,
        };
    }
    // Bottom-nav active state from the URL (the old title comparison broke for
    // "Quantitative" (typo) and for every non-English language).
    isActive(key) {
        key = String(key).toLowerCase();
        const path = window.location.pathname.toLowerCase();
        const map = { home: ["/home"], quatitative: ["/quatitative"], chart: ["/chart"], profile: ["/profile"] };
        if (key === "home" && (path === "/" || path === "")) return true;
        return (map[key] || []).some((p) => path === p || path.startsWith(p + "/"));
    }

    navItem(to, key, label, Icon) {
        const active = this.isActive(key);
        return (
            <Link
                to={to}
                className={active ? "active-nav" : "show-offline"}
                aria-label={label}
                aria-current={active ? "page" : undefined}
            >
                <Icon size={active ? 20 : 22} strokeWidth={active ? 2 : 1.8} />
                <span>{label}</span>
            </Link>
        );
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>CTSBot | {this.state.headerTitle}</title>
                </Helmet>
                <div id="page" className="fintech-shell">
                    <div className="header-bar header-fixed header-app main_header aurora-header">
                        <Link to="/home" className="aurora-header-brand aurora-header-logo" aria-label="CTS Bot">
                            <img src={images['logo']} alt="CTS Bot" />
                        </Link>
                        <Link to="/announcement" className="aurora-icon-btn" aria-label={strings.Latest_Announcement}>
                            <IconBell size={17} />
                        </Link>
                    </div>
                    <nav id="footer-bar" className="footer-bar footer-bar-detached main_footer aurora-nav" aria-label="Main">
                        {this.navItem("/home", "home", strings.Home, IconHome)}
                        {this.navItem("/quatitative", "quatitative", strings.Quantitative, IconQuant)}
                        {this.navItem("/chart", "chart", strings.Chart, IconChart)}
                        {this.navItem("/profile", "profile", strings.Profile, IconProfile)}
                    </nav>
                    <div
                        className="page-content header-clear fintech-page-content"
                        style={{
                            marginTop: 10,
                            overflowY: "scroll",
                        }}
                    >
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}
export default Layout;
